// extracted by mini-css-extract-plugin
export default {"empty_card_box":"card_empty_card_box__3JHcl","empty_card_text":"card_empty_card_text__nrGZh","image_card":"card_image_card__Llhub","image_card_image":"card_image_card_image__3G2In"};